import { useHistory, useLocation } from "react-router-dom";

import { QUERY_KEYS } from "../../constants/queryKeys";

const { TAB } = QUERY_KEYS;

export const useTab = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();

  const handleSelectTab = (selectedIndex: number) => {
    const queryParameters = new URLSearchParams(search);
    queryParameters.set(TAB, `${selectedIndex}`);
    const newLocation = [pathname, queryParameters.toString()].join("?");
    history.push(newLocation);
  };

  return { handleSelectTab, search };
};
